import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import {
  Grid,
  FormControl,
  TextField,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import ApiEndpoints from "../../network/ApiEndPoints";
import { apiErrorToast, okSuccessToast } from "../../utils/ToastUtil";
import { postJsonData } from "../../network/ApiController";
import Loader from "../../component/loading-screen/Loader";
import { primaryColor } from "../../theme/setThemeColor";
import { useState, useEffect, useContext } from "react";
import { PATTERNS } from "../../utils/ValidationUtil";
import ModalHeader from "../ModalHeader";
import ModalFooter from "../ModalFooter";
import AuthContext from "../../store/AuthContext";
import { AEPS_TYPE } from "../../utils/constants";
import Aeps1OutletStatusIpay from "../../component/Aeps1OutletStatusIpay";
import AepsValidateComponent from "../AepsValidateComponent";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "70%",
  bgcolor: "background.paper",
  boxShadow: 24,
  fontFamily: "Poppins",
  p: 2,
  height: "max-content",
  overflowY: "scroll",
};

const AePSOutletRegistration = ({ open, setOpen, refresh, aepsType }) => {
  const [isConsent, setIsConsent] = useState(false);
  const [isValMob, setIsValMob] = useState(true);
  const [request, setRequest] = useState(false);
  const [initiateData, setInitiateData] = useState(null);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [statusReferenceId, setStatusReferenceId] = useState("");
  const [tempData, setTempData] = useState(null);

  const user = useContext(AuthContext);
  const userLat = user.location.lat;
  const userLong = user.location.long;

  useEffect(() => {
    // Reset states when modal closes
    if (!open) {
      setIsConsent(false);
      setIsValMob(true);
      // setInitiateData(null);
      setShowOtpModal(false);
      // setShowStatusModal(false);
      // setTempData(null);
    }
  }, [open]);

  const handleClose = () => {
    setOpen(false);
    setIsConsent(false);
    setIsValMob(true);
    setInitiateData(null);
    setShowOtpModal(false);
    setShowStatusModal(false);
    setTempData(null);
  };

  const outletRegistration = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    // Validate mobile number
    const mobile = form.mobile.value;
    if (!PATTERNS.MOBILE.test(mobile)) {
      setIsValMob(false);
      return;
    }

    const data = {
      mobile: mobile,
      pan: form.pan.value,
      aadhaar: form.aadhaar.value,
      email: form.emailId.value,
      bankAccountNo: form.bankAccountNo.value,
      bankIfsc: form.bankIfsc.value,
      latitude: userLat,
      longitude: userLong,
    };

    setTempData(data);

    postJsonData(
      ApiEndpoints.AEPS_INITIATE,
      data,
      setRequest,
      (res) => {
        okSuccessToast(res?.data?.message);
        setInitiateData(res?.data?.data);
        setShowOtpModal(true); // Show OTP modal
        setStatusReferenceId(res?.data?.data?.otpReferenceID || "");
        if (refresh) refresh();
      },
      (error) => {
        apiErrorToast(error);
      }
    );
  };

  const handleOtpSuccess = (response) => {
    setShowOtpModal(false);
    setShowStatusModal(true);

    if (refresh) {
      refresh();
    }
  };

  const handleOtpClose = () => {
    setShowOtpModal(false);
  };

  const handleStatusModalClose = (statusData) => {
    setShowStatusModal(false);

    handleClose();

    if (statusData?.status === "SUCCESS" && refresh) {
      refresh();
    }
  };

  return (
    <>
      <Modal
        open={open === AEPS_TYPE.AEPS1}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        disableEscapeKeyDown={request}
        disableBackdropClick={request}
      >
        <Box sx={style} className="sm_modal">
          <Loader loading={request} />
          <ModalHeader title="Outlet Registration" handleClose={handleClose} />
          <Box
            component="form"
            id="outletRegistration"
            validate
            autoComplete="off"
            onSubmit={outletRegistration}
            sx={{
              "& .MuiTextField-root": { m: 1 },
            }}
          >
            <Grid container sx={{ pt: 1 }}>
              <Grid item xs={12}>
                <FormControl sx={{ width: "100%" }}>
                  <TextField
                    autoComplete="off"
                    label="Mobile Number"
                    id="mobile"
                    name="mobile"
                    size="small"
                    required
                    helperText={
                      !isValMob
                        ? "Please enter a valid 10-digit mobile number"
                        : ""
                    }
                    error={!isValMob}
                    onChange={(e) => {
                      const isValid = PATTERNS.MOBILE.test(e.target.value);
                      setIsValMob(isValid);
                    }}
                    inputProps={{ maxLength: 10, minLength: 10 }}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <FormControl sx={{ width: "100%" }}>
                  <TextField
                    autoComplete="off"
                    label="PAN"
                    id="pan"
                    name="pan"
                    size="small"
                    required
                    inputProps={{ maxLength: 10 }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl sx={{ width: "100%" }}>
                  <TextField
                    autoComplete="off"
                    label="Aadhaar"
                    id="aadhaar"
                    name="aadhaar"
                    size="small"
                    required
                    inputProps={{ maxLength: 12 }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl sx={{ width: "100%" }}>
                  <TextField
                    autoComplete="off"
                    label="Email ID"
                    id="emailId"
                    name="emailId"
                    size="small"
                    required
                    type="email"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControl sx={{ width: "100%" }}>
                  <TextField
                    autoComplete="off"
                    label="Bank account number"
                    id="bankAccountNo"
                    name="bankAccountNo"
                    size="small"
                    required
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControl sx={{ width: "100%" }}>
                  <TextField
                    autoComplete="off"
                    label="Bank IFSC"
                    id="bankIfsc"
                    name="bankIfsc"
                    size="small"
                    required
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sx={{ mt: 2 }}>
                <FormControlLabel
                  size="small"
                  control={
                    <Checkbox
                      sx={{
                        color: primaryColor(),
                        "&.Mui-checked": {
                          color: primaryColor(),
                        },
                      }}
                      checked={isConsent}
                      onChange={(e) => {
                        setIsConsent(e.target.checked);
                      }}
                    />
                  }
                  label={
                    <span style={{ fontSize: "0.7rem" }}>
                      I hereby give my consent and submit voluntarily at my own
                      discretion, my Aadhaar Number or VID for the purpose of
                      establishing my identity on the portal. The Aadhaar
                      submitted herewith shall not be used for any purpose other
                      than mentioned, or as per the requirements of the law.
                    </span>
                  }
                />
              </Grid>
            </Grid>
          </Box>
          <ModalFooter
            form="outletRegistration"
            request={request}
            btn="Continue"
            disabled={request || !isConsent}
          />
        </Box>
      </Modal>

      {/* OTP Verification Modal */}
      {showOtpModal && initiateData && (
        <AepsValidateComponent
          open={showOtpModal}
          setOpen={setShowOtpModal}
          verifStepSuccRes={initiateData}
          currentStep={3}
          setCurrentStep={() => {}}
          handleCloseCallBk={() => {
            setShowOtpModal(false);
            setShowStatusModal(true);
          }}
          showLaoder={false}
          refreshUser={refresh}
          onSuccess={handleOtpSuccess}
          onClose={handleOtpClose}
          title="Verify OTP for AEPS Registration"
          btn="Verify OTP"
          data={tempData}
          setStatusReferenceId={setStatusReferenceId}
        />
      )}

      {showStatusModal && (
        <Aeps1OutletStatusIpay
          open={showStatusModal}
          onClose={handleStatusModalClose}
          referenceId={statusReferenceId}
          refreshCallback={(data) => {
            if (data?.status === "SUCCESS") {
              okSuccessToast("Outlet registration completed successfully!");
              if (refresh) refresh();
            }
          }}
          showLoader={request}
        />
      )}
    </>
  );
};

export default AePSOutletRegistration;
